export const GRAFANA_VIEWS = {
  ACCOUNT: 'account',
  BOOKS: 'books',
  CATALOGUE: 'catalogue',
  CLASSROOMS: 'classrooms',
  CLASSROOM_MARKS: 'classroom-marks',
  CLASSROOM_MATERIALS: 'classroom-materials',
  CLASSROOM_STUDENTS: 'classroom-students',
  CLASSROOM_TASKS: 'classroom-tasks',
  EVALUATIONS: 'evaluations',
  EVALUATION_CONFIGURATION: 'evaluation-configuration',
  EVALUATION_CREATED: 'evaluation-created',
  EVALUATION_STEPS: 'evaluation-steps',
  HOME: 'home',
  JOIN_CLASS: 'join-class',
  NO_ACTIVITIES: 'no-activities',
  PERSONAL_DATA_CHILD: 'personal-data-child',
  RESOURCES: 'resources',
  SESSION_ERROR: 'session-error',
  STUDENTS: 'students',
  STUDENT_PROFILE: 'student-profile',
  USER_PROFILE: 'user-profile',
}
